// Accueil.vue file

<template>
  <div class="accueil">
    <div class="banniere">
      <div class="bn_img">
        <router-link to="/prestations.html">
          <div class="bn_overlay">
            <div class="bn_txt">
              <i class="fal fa-house-damage"></i>
              <h2>ÉLECTRICITÉ, DOMOTIQUE</h2>
            </div>
          </div>
        </router-link>
        <img
          src="../assets/img/banniere/electricien_panneaux_electrique.jpg"
          alt="Électricité"
        />
      </div>
      <div class="bn_img">
        <router-link to="/prestations.html">
          <div class="bn_overlay">
            <div class="bn_txt">
              <i class="fal fa-solar-panel"></i>
              <h2>PHOTOVOLTAÏQUE</h2>
            </div>
          </div>
        </router-link>
        <img
          src="../assets/img/banniere/panneaux_photovoltaiques.jpg"
          alt="Panneaux photovoltaïque"
        />
      </div>
      <div class="bn_img">
        <router-link to="/prestations.html">
          <div class="bn_overlay">
            <div class="bn_txt">
              <i class="fal fa-air-conditioner"></i>
              <h2>CHAUFFAGE, CLIMATISATION</h2>
            </div>
          </div>
        </router-link>
        <img
          src="../assets/img/banniere/pompes_a_chaleur.jpg"
          alt="Pompe à chaleur"
        />
      </div>
      <div class="bn_img">
        <router-link to="/prestations.html">
          <div class="bn_overlay">
            <div class="bn_txt">
              <i class="fal fa-outlet"></i>
              <h2>ÉLECTRICITÉ TERTIAIRE ET INDUSTRIELLE</h2>
            </div>
          </div>
        </router-link>
        <img src="../assets/img/banniere/multimetre.jpg" alt="Domotique" />
      </div>
    </div>
    <div class="container">
      <div class="page">
        <div class="a-presentation">
          <h1>Un électricien au service de vos économies</h1>
          <div class="a-content">
            <div class="label">
              <a
                href="https://www.les-energies-renouvelables.eu/conseils/tout-savoir-sur-la-qualification-rge-reconnu-garant-environnement/quest-ce-que-le-label-rge/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="../assets/img/Qualifications/label_rge_r1_c1.png"
                  alt="Label RGE"
                />
              </a>
            </div>
            <div class="a-txt">
              <p>
            Bienvenue à l'entreprise Jean-Luc BOAS à Gimont dans le Gers, à
            proximité de L'isle Jourdain et Auch.
          </p>
          <p>Une entreprise avec plus de 25 ans d’expérience !</p>
              <p>Études, réalisations et dépannages.</p>
              <p>
                Électricité générale, bâtiments neufs ou rénovations, tertiaire
                ou industrielle.
              </p>
              <p>
                Climatisations et pompes à chaleur, installations et
                maintenances.
              </p>
              <p>Photovoltaïques en vente totale ou en autoconsommation.</p>
              <p>Domotique, automatismes portail, alarmes.</p>
            </div>
          </div>
          <router-link to="/contact.html">
            <button class="btn_devis">DEMANDEZ UN DEVIS</button>
          </router-link>
        </div>
        <div class="a_title">
          <h2>NOS DERNIÈRES RÉALISATIONS</h2>
        </div>
        <div class="actualites">
          <div
            class="actualites_content"
            v-for="(realisation, index) in dataArray.slice(0, 3)"
            :key="'realisation' + index"
          >
            <router-link
              :to="{
                name: 'realisation',
                params: {
                  id: realisation.idA,
                  title: deleteSpace(
                    deleteParenthesis(realisation.titleA.toLowerCase())
                  )
                }
              }"
            >
              <div
                class="actualites_img"
                :style="{
                  backgroundImage:
                    'url(https://cdn-gbbu02.graphibox.eu/pub/4/medias/achievements/' +
                    realisation.idA +
                    '/' +
                    realisation.pictureThumbA +
                    ')'
                }"
              >
                <div class="actualites_over">
                  <div class="actualites_over-txt">
                    <p>{{ realisation.titleA.toUpperCase() }}</p>
                    <i class="fal fa-plus-circle"></i>
                  </div>
                </div>
              </div>
              <div class="actualites_title">
                <h3>{{ realisation.titleA }}</h3>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prestaMixin } from "../mixins/prestaMixin";
import { titleMixin } from "../mixins/titleMixin";

export default {
  metaInfo: {
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Entreprise Jean-Luc BOAS spécialisée dans l'électricité générale, tertiaire et industriel, dans la domotique, dans le photovoltaïque ainsi que dans la climatisation et le chauffage à Gimont dans le Gers "
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "Électricité générale, Électricité tertiaire, Électricité industriel, Domotique, Photovoltaïque, Chauffage, Climatisation, Gimont, Gers"
      }
    ]
  },
  name: "accueil",
  mixins: [prestaMixin, titleMixin],
  data() {
    return {
      title: "BOAS électricien climatisation photovoltaïque Gimont Gers 32"
    };
  }
};
</script>

<style scoped>
/* BANNIERE */
.banniere {
  display: flex;
  justify-content: flex-start;
}
.bn_img {
  position: relative;
  width: 30%;
  height: inherit;
}
.bn_img img {
  width: 100%;
  height: 100%;
}
.bn_img a {
  color: white;
}
.bn_overlay {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background-color: rgba(173, 17, 30, 0.7);
  overflow: hidden;
  width: 100%;
  height: 0;
  transition: all 0.5s ease-out;
  cursor: pointer;
  text-align: center;
}
.bn_img:hover .bn_overlay {
  bottom: 0;
  height: 100%;
  transition: all 0.6s ease-out;
}
.bn_txt {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bn_txt h2 {
  font-size: 1.2rem;
}
.bn_txt p {
  font-size: 1rem;
}
.fa-solar-panel,
.fa-air-conditioner,
.fa-house-damage,
.fa-outlet {
  font-size: 2rem;
}

/* TEXTE DE PRESENTATION */
.a-presentation {
  margin-top: 2rem;
  font-family: Montserrat-SemiBold;
  margin: auto;
  text-align: center;
}
.a-presentation p {
  font-size: 0.8rem;
}
.a-presentation h1 {
  text-align: center;
  font-size: 2.2rem;
}
.a-content {
  display: flex;
  justify-content: center;
  width: 58%;
  margin: auto;
}
.a-txt {
  text-align: left;
  padding-left: 5rem;
}
.label {
  margin-top: 3.2rem;
}
.label img {
  filter: grayscale(0%);
  transition: all 0.3s ease-out;
}
.label img:hover {
  filter: grayscale(100%);
  transition: all 0.3s ease-out;
}
.a-presentation button {
  font-family: Montserrat-SemiBold;
  color: white;
  background-color: black;
  border: 1px solid black;
  border-radius: 3px;
  margin: 2rem 0 4rem 0;
  padding: 1rem;
  cursor: pointer;
}
.a-presentation button:hover {
  background-color: white;
  color: black;
}

/* IMAGES DES ACTUALITES */
.a_title {
  text-align: center;
  color: rgb(173, 17, 30);
  padding: 1rem;
}
.actualites {
  display: flex;
  justify-content: space-between;
  margin: auto;
  padding-bottom: 3rem;
  width: 60%;
}
.actualites_content {
  width: 32%;
  height: 200px;
}
.actualites_img {
  position: relative;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  transition: all 0.6s ease-out;
}
.actualites_over {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.6s ease-out;
  color: white;
  background-color: rgba(0, 0, 0, 0.712);
}
.actualites_img:hover .actualites_over {
  opacity: 1;
  cursor: pointer;
  transition: all 0.6s ease-out;
}
.actualites_over-txt {
  text-align: center;
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.fa-plus-circle {
  font-size: 2rem;
}
.actualites_title {
  display: none;
  font-size: 0.9rem;
  text-align: center;
  color: black;
}

/* RESPONSIF */
@media all and (max-width: 1000px) {
  .actualites {
    width: 70%;
  }
  .a-content {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
  }
  .a-txt {
    text-align: center;
    padding: 0;
  }
  .label {
    margin-top: 1rem;
  }
}

@media all and (max-width: 800px) {
  .banniere {
    flex-wrap: wrap;
  }
  .bn_img {
    width: 50%;
  }
  .actualites {
    width: 80%;
  }
}

@media all and (max-width: 760px) {
  .actualites {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .actualites_content {
    width: 80%;
    margin-bottom: 4rem;
  }
  .actualites_title {
    display: block;
  }
}
</style>
